import { get, jsonPut, jsonPost, del } from '@client/lib/request';
import { Cart, RecoveredCart, AddItemProps, transformCart, getNow } from '@pegasus/cart';
import { CSRF_HEADER } from '@shared/constants';

export const getCart = (): Promise<Cart> => {
    return get('/api/phoenix/stockcart/cart')
        .then(transformCart)
        .catch(() => ({
            items: [],
            expiresIn: 0,
            expiresAt: getNow(),
            savings: 0,
            total: 0,
            shippingCosts: 0,
            discountPercent: 0,
        }));
};

export const extendCart = () =>
    jsonPut('/api/phoenix/stockcart/cart', null, {
        headers: {
            [CSRF_HEADER]: window.CSRF,
        },
    });

export const deleteCartItem = (itemSku: string) =>
    del(`/api/phoenix/stockcart/cart/items/${itemSku}`, null, {
        headers: {
            [CSRF_HEADER]: window.CSRF,
        },
    });

export const deleteAllItemsFromCart = () =>
    del('/api/phoenix/stockcart/cart', null, {
        headers: {
            [CSRF_HEADER]: window.CSRF,
        },
    });

export const addItemToCart = ({ quantity = 1, ...props }: AddItemProps) =>
    jsonPost(
        '/api/phoenix/stockcart/cart/items',
        { quantity, ...props },
        {
            headers: {
                [CSRF_HEADER]: window.CSRF,
            },
        },
    );

export const getRecoveredCart = (): Promise<RecoveredCart> => get('/api/recovered-cart');
